import { useEnvironment } from '@wix/yoshi-flow-editor';

import { useCanEditMember, useMember } from '../../../../contexts/widgets';
import { useCascadingSettings } from '../../Settings/hooks';
import settingsParams from '../../settingsParams';
import stylesParams from '../../stylesParams';

export const useCustomProfile = () => {
  const { canEditMember } = useCanEditMember();
  const { customProfile } = useMember();

  if (!canEditMember) {
    const { fields, socialLinks } = customProfile;
    return {
      fields: fields.filter(({ value }) => value?.length),
      socialLinks: socialLinks.filter(({ href }) => href),
    };
  }

  return customProfile;
};

export const useOverviewRenderer = () => {
  const { isEditor } = useEnvironment();
  const { fields, socialLinks } = useCustomProfile();
  const cascadingSettings = useCascadingSettings();

  const showOverviewSection = cascadingSettings.get(
    settingsParams.showOverviewSection,
    stylesParams.showOverviewSection,
  );
  const hasCustomProfile = fields.length > 0 || socialLinks.length > 0;

  return {
    shouldRenderOverview: showOverviewSection && (isEditor || hasCustomProfile),
  };
};
